// Import Services.
import * as Logger from '../../common/tools/logger';
import { CommunicationHandlerService } from '../tools/communication-handler.service';

/**
 * @class
 * @name PermissionCoreApp
 * @description Provides the business logic as a CMP (Consent Management Platform) to handle and process users permission data.
 */
export class PermissionCoreApp {

  /**
   * @var {string} moduleName Reflects the modules name.
   */
  private moduleName = `PermissionCoreApp`;

  /**
   * @var {CommunicationHandlerService} communicationHandlerService Instantiate a new `CommunicationHandlerService`.
   */
  private communicationHandlerService: CommunicationHandlerService = new CommunicationHandlerService();

  /**
   * @constructor
   */
  constructor() {
    this.initialize();
  }

  /**
   * @private
   * @async
   * @function initialize
   * @description Function to initialize the app functionality itself, beware order.
   * @return {Promise<void>}
   */
  private async initialize(): Promise<void> {

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return new Promise<void>(async (resolve: () => void) => {

      // Performance Start.
      let performanceStart: number;
      if (typeof window.performance.now === 'function') {
        performanceStart = window.performance.now();
      }

      try {

        // Initialize Communication Handler.
        await this.communicationHandlerService.initialize();

        let performanceMsg = '';
        if (performanceStart) {
          performanceMsg = ` after ${Math.round(window.performance.now() - performanceStart)} ms.`;
        }

        // Log.
        Logger.debug(this.moduleName, `initialize`, `Module initialized after${performanceMsg}`);

        // Resolve.
        return resolve();
      } catch (error) {
        Logger.error(this.moduleName, `initialize`, error);
        return resolve();
      }
    });
  }
}
